import classnames from 'classnames';
import { Button } from '@stadionhq-v3/base-ui';
import { signIn } from 'next-auth/react';
import styles from './streamPackagePlayerOverlay.module.scss';
import { StreamPackagePlayerOverlayProps } from './streamPackagePlayerOverlay.types';

const StreamPackagePlayerOverlay = ({
  title,
  message,
  cta,
  signInCta,
  registerCta,
  classNames = [],
  nativeProps = {},
}: StreamPackagePlayerOverlayProps) => {
  const classes = classnames([styles.streamPackagePlayerOverlay], classNames);
  return (
    <div {...nativeProps} className={classes}>
      <div className={styles.container}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {message && <p className={styles.message}>{message}</p>}
        {cta && (
          <Button
            url={cta.url}
            variant="primary"
            onDark
            classNames={[styles.cta as string]}
            text={cta.label}
          />
        )}
        {signInCta && (
          <Button
            onClick={() => {
              signIn('default', {
                callbackUrl: `${window.location.href}/`,
              });
            }}
            variant="primary"
            onDark
            classNames={[styles.cta as string]}
            text={signInCta.label}
          />
        )}
        {registerCta && (
          <Button
            onClick={() => {
              signIn('default', {
                callbackUrl: `${window.location.href}/`,
              });
            }}
            onDark
            variant="text-button"
            classNames={[styles.cta as string]}
            text={registerCta.label}
          />
        )}
      </div>
    </div>
  );
};

export default StreamPackagePlayerOverlay;
